import { createEvent, createStore } from "effector-logger";

import {
    InputSurveyModify,
    App,
    Source,
    OptionAction,
    TortQualifySurvey,
} from "reliance-private-sitebuilder-schema/dist/API";

import { v4 as uuidv4 } from "uuid";

import { ModificationError } from "../types/types";

// import * as _ from "lodash";

export interface surveyStore {
    holdingSurvey?: Partial<InputSurveyModify>;
    section: string;
    questionEditId: string;
    errors: ModificationError[];
    apps: App[];
    sources: Source[];
    tqsurveys: Partial<TortQualifySurvey>[];
    mode: string;
}

export const emptySurveyStore: surveyStore = {
    holdingSurvey: {
        name: "",
        questions: [],
    },
    section: "basics",
    questionEditId: "",
    errors: [],
    apps: [],
    sources: [],
    tqsurveys: [],
    mode: "",
};

export type ModifyQuestionDetails = {
    idx: number;
    fieldName: string;
    fieldValue?: string;
    fieldValues?: string[];
};

export type ModifyOptionDetails = {
    qIdx: number;
    idx: number;
    fieldName: string;
    fieldValue?: string;
    fieldValues?: string[];
};
export type ModifyOptionMultiStringDetails = {
    qIdx: number;
    oIdx: number;
    iIdx: number;
    fieldName: string;
    fieldValue?: string;
    field: string;
};
export type AddOptionMultiStringDetails = {
    qIdx: number;
    oIdx: number;
    field: string;
};
export type RemoveOptionMultiStringDetails = {
    qIdx: number;
    oIdx: number;
    iIdx: number;
    field: string;
};

export type AddOptionDetails = {
    qIdx: number;
};
export type RemoveOptionDetails = {
    qIdx: number;
    idx: number;
};

export type ModifySurveyDetails = {
    fieldName: string;
    fieldValue?: string;
    fieldValues?: string[];
};

export const updateSurveyStore = createEvent<Partial<surveyStore>>();

export const modifyQuestionDetails = createEvent<ModifyQuestionDetails>();
export const addQuestion = createEvent();
export const removeQuestion = createEvent<number>();

export const modifySurveyDetails = createEvent<ModifySurveyDetails>();

export const modifyOptionDetailsMultiString = createEvent<ModifyOptionMultiStringDetails>();
export const addOptionDetailsMultiString = createEvent<AddOptionMultiStringDetails>();
export const removeOptionDetailsMultiString = createEvent<RemoveOptionMultiStringDetails>();

export const modifyOptionDetails = createEvent<ModifyOptionDetails>();
export const addOption = createEvent<AddOptionDetails>();
export const removeOption = createEvent<RemoveOptionDetails>();

export const resetSurvey = createEvent();

export default createStore<surveyStore>(emptySurveyStore)
    .on(updateSurveyStore, (state, s) => {
        return {
            ...state,
            ...s,
        };
    })
    .on(resetSurvey, (state) => {
        return {
            ...emptySurveyStore,
        };
    })
    .on(modifySurveyDetails, (state, payload) => {
        var update: any = {};
        if (payload.fieldValues) {
            update[payload.fieldName] = payload.fieldValues;
        } else {
            update[payload.fieldName] = payload.fieldValue;
        }
        state.holdingSurvey = {
            ...state.holdingSurvey,
            ...update,
        };
        return {
            ...state,
        };
    })
    .on(modifyQuestionDetails, (state, payload) => {
        var fieldNameSplit = payload.fieldName.split("#");
        var fieldName = fieldNameSplit[0];
        var update: any = {};
        update[fieldName] = payload.fieldValue;
        state.holdingSurvey!.questions![payload.idx]! = {
            ...state.holdingSurvey!.questions![payload.idx]!,
            ...update,
        };
        return {
            ...state,
        };
    })
    .on(modifyOptionDetails, (state, payload) => {
        var fieldNameSplit = payload.fieldName.split("#");
        var fieldName = fieldNameSplit[0];
        var update: any = {};
        update[fieldName] = payload.fieldValue;
        state.holdingSurvey!.questions![payload.qIdx]!.options![payload.idx]! = {
            ...state.holdingSurvey!.questions![payload.qIdx]!.options![payload.idx]!,
            ...update,
        };
        /// unset action if it is not a valid option (such as no action)
        if (payload.fieldName.startsWith("action#") && !Object.keys(OptionAction).includes(payload.fieldValue!)) {
            delete state.holdingSurvey!.questions![payload.qIdx]!.options![payload.idx]!.action;
        }
        return {
            ...state,
        };
    })
    .on(addOptionDetailsMultiString, (state, payload) => {
        if (!state.holdingSurvey!.questions![payload.qIdx]!.options![payload.oIdx]![payload.field]) {
            state.holdingSurvey!.questions![payload.qIdx]!.options![payload.oIdx]![payload.field] = [];
        }
        state.holdingSurvey!.questions![payload.qIdx]!.options![payload.oIdx]![payload.field]?.push("");
        return {
            ...state,
        };
    })
    .on(removeOptionDetailsMultiString, (state, payload) => {
        state.holdingSurvey!.questions![payload.qIdx]!.options![payload.oIdx]![payload.field].splice(payload.iIdx, 1);
        return {
            ...state,
        };
    })
    .on(modifyOptionDetailsMultiString, (state, payload) => {
        state.holdingSurvey!.questions![payload.qIdx]!.options![payload.oIdx]![payload.field][payload.iIdx]! =
            payload.fieldValue!;
        return {
            ...state,
        };
    })
    .on(addOption, (state, payload) => {
        if (!state.holdingSurvey!.questions![payload.qIdx]!.options) {
            state.holdingSurvey!.questions![payload.qIdx]!.options = [];
        }
        state.holdingSurvey!.questions![payload.qIdx]!.options!.push({
            id: uuidv4(),
            value: "",
        });
        return {
            ...state,
        };
    })
    .on(removeOption, (state, payload) => {
        state.holdingSurvey!.questions![payload.qIdx]!.options!.splice(payload.idx, 1);
        return {
            ...state,
        };
    })
    .on(addQuestion, (state) => {
        state.holdingSurvey!.questions!.push({
            id: uuidv4(),
            description: "",
        });
        return {
            ...state,
        };
    })
    .on(removeQuestion, (state, idx) => {
        state.holdingSurvey!.questions!.splice(idx, 1);
        return {
            ...state,
        };
    });
